var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"button-get-into",style:(_vm.btnStyles)},[_c('b-button',{attrs:{"size":"lg","btnType":_vm.btnType},on:{"click":_vm.onclick}},[_vm._v(_vm._s(_vm.text))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }